<template>
  <tr :key="id">
    <td class="col-4">{{ product.description }}</td>
    <td align="center" class="col-2">
      {{ roundAndFormat(product.quantityPurchased, decimalConfiguration.quantity) }}
    </td>
    <td align="center" class="col-1">
      {{ product.fiscal.values.cfop.codigo }}
    </td>
    <td align="center" class="col-2">
      {{ roundAndFormat(product.price, decimalConfiguration.price) }}
    </td>
    <td align="center" class="col-2">R$ {{ buildTotalProduct(product) }}</td>
    <td align="center" class="col-1">
      <a
        href="javascript:"
        @click="handleToggleModalFiscalProduct(id)"
        class="toogle-modal-product pr-2 text-muted"
      >
        <Edit title="Editar" />
      </a>
      <a
        href="javascript:"
        @click="removeProductOfPurchaseCollection(id)"
        class="remove-product text-muted"
      >
        <Close title="Excluir" />
      </a>
    </td>
  </tr>
</template>

<script>
import Close from 'vue-material-design-icons/Close';
import Edit from 'vue-material-design-icons/Pencil';
import { mapActions, mapGetters, mapState } from 'vuex';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import { CalcTypesPurchaseEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import MathUtils from '@/reusable/mathUtils';

export default {
  name: 'Product',
  mixins: [FormatMixin],
  components: {
    Close,
    Edit,
  },
  props: ['product', 'id'],
  computed: {
    ...mapState('purchase', [
      'products',
      'purchaseParams',
      'productOfPurchaseOnFiscalEdit',
      'taxInformation',
      'supplierInformation',
    ]),
    ...mapGetters('purchase', ['decimalConfiguration']),
  },
  methods: {
    ...mapActions('purchase', [
      'setProductOfPurchaseOnFiscalEdit',
      'setRemainder',
      'totalCalcPurchase',
      'setUnitOfMeasureById',
      'setCfopByIdForProduct',
      'setCsosnById',
      'setCenqById',
      'setOrigemById',
      'setCstById',
      'setCstIpiById',
      'setCstPisById',
      'setCstCofinsById',
      'setNaturezaError',
      'setSupplierError',
    ]),
    ...mapActions('componentsPurchase', ['toggleModalProduct']),
    buildTotalProduct(product) {
      const vDesc = product.vDesc ?? 0;
      const total = new MathUtils(product.price)
        .multiply(product.quantityPurchased)
        .subtract(vDesc)
        .toNumber();
      return this.roundAndFormat(total, this.decimalConfiguration.price);
    },
    async handleToggleModalFiscalProduct(e) {
      const { isInformed, error } = this.headerCFOPAndSupplierInformed();
      if (!isInformed) {
        this.$alert.error(error);
        return;
      }
      const { fiscal, ...productData } = this.products.productOfPurchaseCollection[e];

      await this.setProductOfPurchaseOnFiscalEdit({
        edited: productData.edited,
        isImportation: productData.isImportation,
        originalIndex: e,
        productData,
        fiscal,
      });

      if (productData.edited || productData.isImportation) {
        await this.setFiscalOnEdit(fiscal);
      }

      await this.toggleModalProduct();
    },
    async setFiscalOnEdit(fiscal) {
      const { id } = this.productOfPurchaseOnFiscalEdit.productData.unitOfMeasure;
      const {
        csosnId,
        cenqId,
        origemId,
        cstId,
        cfopId,
        cstIPIId,
        cstPISId,
        cstCOFINSId,
      } = fiscal.ids;

      await Promise.all([
        this.setUnitOfMeasureById(id),
        this.setCfopByIdForProduct(cfopId),
        this.setCsosnById(csosnId),
        this.setCenqById(cenqId),
        this.setOrigemById(origemId),
        this.setCstById(cstId),
        this.setCstIpiById(cstIPIId),
        this.setCstPisById(cstPISId),
        this.setCstCofinsById(cstCOFINSId),
      ]);
    },

    async removeProductOfPurchaseCollection(id) {
      this.products.productOfPurchaseCollection.splice(id, 1);
      await this.totalCalcPurchase({
        calcTypes: [
          CalcTypesPurchaseEnum.TOTAL_ATTRIBUTES,
          CalcTypesPurchaseEnum.TOTAL_COMMON,
          CalcTypesPurchaseEnum.TOTAL_DESC_BASED_ON_ITEM,
          CalcTypesPurchaseEnum.TOTAL_NF,
          CalcTypesPurchaseEnum.TOTAL_TAX_REGIME,
        ],
      });
    },

    headerCFOPAndSupplierInformed() {
      const response = { isInformed: false, error: null };

      if (!this.taxInformation.natureza.cfop.codigo) {
        this.setNaturezaError(true);
        return { ...response, error: 'Natureza não informada' };
      }
      if (!this.supplierInformation.supplier.name) {
        this.setSupplierError(true);
        return { ...response, error: 'Fornecedor não informado' };
      }

      return { ...response, isInformed: true };
    },
  },
};
</script>
